import { render } from "./NeurologicalDiseaseOverallSurvival.vue?vue&type=template&id=62ca1749&scoped=true"
import script from "./NeurologicalDiseaseOverallSurvival.vue?vue&type=script&lang=js"
export * from "./NeurologicalDiseaseOverallSurvival.vue?vue&type=script&lang=js"

import "./NeurologicalDiseaseOverallSurvival.vue?vue&type=style&index=0&id=62ca1749&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ca1749"]])

export default __exports__